module.exports = "/assets/site/images/icon-arrow-double-left.png?880838b0e0ef643eb4e7d0780af4d5f2";